import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/data/site";

const Banner = () => (
  <div
    data-testid="emergency-banner"
    className="relative z-[60] bg-bear-red text-white"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-2 text-center">
      <span className="pulse-dot hidden h-2 w-2 shrink-0 rounded-full bg-white sm:block" />
      <p className="font-head text-[11px] font-semibold uppercase tracking-[0.14em] sm:text-xs">
        After-Hours &amp; Weekend Service Available (5 PM – 9 PM)
      </p>
      <span className="hidden h-3 w-px bg-white/40 sm:block" />
      <a
        data-testid="banner-call-link"
        href={PHONE_TEL}
        className="group flex items-center gap-1.5 font-head text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs"
      >
        <Phone className="h-3.5 w-3.5 transition-transform duration-300 group-hover:rotate-12" />
        <span className="underline-offset-4 group-hover:underline">Call {PHONE_DISPLAY}</span>
      </a>
    </div>
  </div>
);

export default Banner;
